import { render } from "./featuresAndCaracteristics.vue?vue&type=template&id=4afcb9ca&scoped=true"
import script from "./featuresAndCaracteristics.vue?vue&type=script&lang=js"
export * from "./featuresAndCaracteristics.vue?vue&type=script&lang=js"

import "./featuresAndCaracteristics.vue?vue&type=style&index=0&id=4afcb9ca&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4afcb9ca"]])

export default __exports__